import {
  IProveChallengeRequest,
  IProveChallengeResponse,
  IProveCompleteResponse,
  IProveStartPayload,
  IProveStartResponse,
  IProveValidateResponse,
  IUserInformationPayload,
  IValidateRequestPayload,
} from 'types/proveIdentity';
import { ErrorResponse } from 'types/form';
import { ApiResources, createErrorResponse, getRequestHeaders, getUrl, Methods, processResponse } from './utils';

export const start = async (startPayload: IProveStartPayload, anonymous_id?: string | null): Promise<IProveStartResponse | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.proveStart)}${anonymous_id ? `?anonymousId=${anonymous_id}` : ''}`;
  const request = {
    method: Methods.post,
    headers: await getRequestHeaders(),
    body: JSON.stringify(startPayload),
  };
  try {
    const startResponse = await fetch(endpoint, request);
    return processResponse(startResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};

export const validate = async (
  validateRequestPayload: IValidateRequestPayload
): Promise<IProveValidateResponse | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.proveValidate)}`;
  const request = {
    method: Methods.post,
    headers: await getRequestHeaders(),
    body: JSON.stringify(validateRequestPayload),
  };
  try {
    const validateResponse = await fetch(endpoint, request);
    return processResponse(validateResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};

export const challenge = async (
  challengeRequestPayload: IProveChallengeRequest
): Promise<IProveChallengeResponse | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.proveChallenge)}`;
  const request = {
    method: Methods.post,
    headers: await getRequestHeaders(),
    body: JSON.stringify(challengeRequestPayload),
  };
  try {
    const challengeResponse = await fetch(endpoint, request);
    return processResponse(challengeResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};

export const complete = async (userInformation: IUserInformationPayload): Promise<IProveCompleteResponse | ErrorResponse> => {
  const endpoint = `${getUrl(ApiResources.proveComplete)}`;
  const request = {
    method: Methods.post,
    headers: await getRequestHeaders(),
    body: JSON.stringify(userInformation),
  };
  try {
    const completeResponse = await fetch(endpoint, request);
    return processResponse(completeResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};
